import App from 'app/app.js';
import LtSelectionDrawerCtrl from 'app/directive/LtSelectionDrawerCtrl.js';

function LtConfirmDeleteDrawerCtrl($scope, $timeout) {
  LtSelectionDrawerCtrl.call(this, $scope, $timeout);

  this.answer = function (value) {
    $scope.onAnswer({ value: value });
  };
}

App.controller('LtConfirmDeleteDrawerCtrl', ['$scope', '$timeout', LtConfirmDeleteDrawerCtrl]);
